//@flow

import {useActions} from '../../../utils/globalStore';
import {useRealTimeListener} from '../../real-time/utils';

import {actions as notificationActions} from '../duck';

import {endpoints} from '../api';
import {useCallback, useEffect, useState} from 'react';
import {getRealTimeAuthenticationTokenService} from '../promises';
import {useUser} from '../../auth/utils';
import {useNotificationSound} from '../../../utils/react/useNotificationSound';

import newOrderCreated from '../../../assets/sounds/order-created-sound.mp3';

export function useListenNotifications() {
  const [token, setToken] = useState('');

  const user = useUser();

  useEffect(() => {
    if (!user) return;
    getRealTimeAuthenticationTokenService()
      .then(response => {
        setToken(response.token);
      })
      .catch(error => {
        console.error(
          `Error al conectarse al servidor de mensajes, recarga la página, Error ${error}`
        );
      });
  }, [user]);

  const playSound = useNotificationSound(newOrderCreated);

  const addNotifications = useActions(
    notificationActions.addUnseenNotifications
  );

  const alertNewOrder = useCallback(() => {
    const originalTitle = document.title;
    document.title = 'Nuevo pedido';

    setTimeout(() => {
      document.title = originalTitle;
    }, 2000);
  }, []);

  const {open, connecting} = useRealTimeListener(
    token && `${endpoints.NOTIFICATION_STREAM}?t=${token}`,
    {
      onMessage: data => {
        if (!data.Message) return;

        const message = JSON.parse(data.Message);
        addNotifications([message]);

        if (message.notificationType.name === 'ORDER_CREATED') {
          playSound();
          alertNewOrder();
        }
      },
      onError: error => {
        console.log('error', error);
      },
    }
  );

  return {
    listening: open || connecting,
  };
}
